import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ExistingAccountComponent } from './existing-account/existing-account.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HomepageComponent } from './homepage/homepage.component';
import { InactiveAccountComponent } from './inactive-account/inactive-account.component';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { SignupCompletedComponent } from './signup-completed/signup-completed.component';
import { SignupComponent } from './signup/signup.component';
import { UserComponent } from './user.component';
import { UserRouting } from '../../routes/user.routing';
import { MatIconModule } from '@angular/material/icon';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    UserRouting,
    MatIconModule,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
  ],
  declarations: [
    UserComponent,
    LoginComponent,
    // ExistingAccountComponent,
    // ForgotPasswordComponent,
    // HomepageComponent,
    // InactiveAccountComponent,
    // PasswordResetComponent,
    // SignupCompletedComponent,
    // SignupComponent,
  ],
  exports: [UserComponent],
  providers: []
})
export class UserModule { }
